import React, { useState } from 'react';
import { useMemoService } from '../../../sdk/MemoServiceClient';
import { Error } from '@app/shared';
import { useGlobalContext } from '../../../GlobalContextProvider';

export function AddEditMemo({ customerId, onMemoAdded }: { customerId: string; onMemoAdded: () => void }) {
  const [note, setNote] = useState<string>(undefined);
  const { tenantId } = useGlobalContext();
  const memoService = useMemoService(tenantId);
  const [error, setError] = useState<string | undefined>(undefined);
  const [submitting, setSubmitting] = useState<boolean>(false);

  async function onCreateMemo(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await memoService.addCustomerMemo(customerId, { note });
      onMemoAdded();
      setNote(undefined);
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      setError(e);
    }
  }

  return (
    <form className="ui form" onSubmit={(e) => onCreateMemo(e)}>
      <Error error={error} />
      <div className="field">
        <div className="ui labeled input">
          <div className="ui label">Note</div>
          <input
            required
            type="text"
            value={note || ''}
            onChange={(e) => setNote(e.target.value)}
            disabled={submitting}
          />
          <button className={`ui button ${submitting && 'loading'}`} type="submit">
            Add Memo
          </button>
        </div>
      </div>
    </form>
  );
}
